import React, { FC } from "react";
import * as styles from './styles.module.scss';
// import { GatsbyImage, getImage } from "gatsby-plugin-image"

import cls from 'classnames';
import { IdHeading } from "components/organisms/IdHeading";

type heading = 1 | 2 | 3 | 4 | 5 | 6

export type Props = {
  background?: string
  backgroundImage?: string
  spread?: boolean
  slim?: boolean

  style?: React.CSSProperties

  title?: string
  description?: React.ReactNode | string
  image?: string

  badge?: string

  button?: {
    modalId: string
    href?: string
    caption: string
  }

  className?: string
  childrenClassNames?: {
    title?: string
    description?: string
    icon?: string
    image?: string
    content?: string
    body?: string
    badge?: string
    button?: string
    wrapper?: string
  }
  body?: React.ReactNode | string

  icon?: string,
  headingLevel?: heading

  link?: string
  tags?: React.ReactNode
}

export const ProductCard: FC<Props> = (props) => {
  const {
    title,
    description,
    icon,
    button,
    badge,
    background,
    body,
    backgroundImage,
    image,
    style = {},
    className,
    childrenClassNames,
    headingLevel = 3,
    link,
    tags
  } = props;

  const renderButton = (button: Record<string, string>) => {

    if (button.modalId) {
      return (
         <button key={button.caption} 
                data-bs-toggle="modal" data-bs-target={button.modalId}
                className={cls(styles.button, 'button-filled', childrenClassNames?.button)}
                style={style}>
            {button.caption}
        </button>
      )
    }

    return (
      <a
        key={button.caption}
        className={cls(styles.button, "button-filled", childrenClassNames?.button)}
        href={button.href}
      >
        {button.caption}
      </a>
    );
  };

  return (
      <>
        {link ? (
  <a
    href={link}
    className={cls(styles.wrapper, className, childrenClassNames?.wrapper)}
    style={{ background, backgroundImage, ...style }}
  >
    <div className={cls(styles.content, { [styles.withBadge]: Boolean(badge) || props.spread }, childrenClassNames?.content)}>
      {badge && <span className={cls(styles.badge, childrenClassNames?.badge)}>{badge}</span>}
      <div className={cls(styles.contentBody, styles.content, { [styles.withBadge]: Boolean(badge) || props.spread })}>
        {icon && <img className={cls(styles.icon, childrenClassNames?.icon)} src={icon} alt={title} />}
        {title && <IdHeading headingLevel={headingLevel} className={cls(styles.title, childrenClassNames?.title)}>{title}</IdHeading>}
        {description &&
          (typeof description === "string" ? (
            <p
              className={cls(
                childrenClassNames?.description?.includes("color-") ? "" : "color-gray",
                styles.description,
                props.spread ? styles.growable : "",
                childrenClassNames?.description
              )}
            >
              {description}
            </p>
          ) : (
            <div
              className={cls(
                childrenClassNames?.description?.includes("color-") ? "" : "color-gray",
                styles.description,
                props.spread ? styles.growable : "",
                childrenClassNames?.description
              )}
            >
              {description}
            </div>
          ))}
        {body && <div className={cls(styles.body, childrenClassNames?.body)}>{body}</div>}
        {Array.isArray(button)
          ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "5px 10px", marginTop: 40 }}>
              {button.map(renderButton)}
            </div>
          ) : (
            button && renderButton(button)
          )}
      </div>
    </div>
    {image && <img className={cls(styles.image, childrenClassNames?.image)} src={image} alt="media" />}
    {tags && <div className={cls(styles.tags)}>{tags}</div>}
  </a>
  ) : (
  <div
    className={cls(styles.wrapper, className, childrenClassNames?.wrapper)}
    style={{ background, backgroundImage, ...style }}
  >
    <div className={cls(styles.content, { [styles.withBadge]: Boolean(badge) || props.spread }, childrenClassNames?.content)}>
      {badge && <span className={cls(styles.badge, childrenClassNames?.badge)}>{badge}</span>}
      <div className={cls(styles.contentBody, styles.content, { [styles.withBadge]: Boolean(badge) || props.spread })}>
        {icon && <img className={cls(styles.icon, childrenClassNames?.icon)} src={icon} alt={title} />}
        {title && <IdHeading headingLevel={headingLevel} className={cls(styles.title, childrenClassNames?.title)}>{title}</IdHeading>}
        {description &&
          (typeof description === "string" ? (
            <p
              className={cls(
                childrenClassNames?.description?.includes("color-") ? "" : "color-gray",
                styles.description,
                props.spread ? styles.growable : "",
                childrenClassNames?.description
              )}
            >
              {description}
            </p>
          ) : (
            <div
              className={cls(
                childrenClassNames?.description?.includes("color-") ? "" : "color-gray",
                styles.description,
                props.spread ? styles.growable : "",
                childrenClassNames?.description
              )}
            >
              {description}
            </div>
          ))}
        {body && <div className={cls(styles.body, childrenClassNames?.body)}>{body}</div>}
        {Array.isArray(button)
          ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "5px 10px", marginTop: 40 }}>
              {button.map(renderButton)}
            </div>
          ) : (
            button && renderButton(button)
          )}
      </div>
    </div>
    {image && <img className={cls(styles.image, childrenClassNames?.image)} src={image} alt="media" />}
    {tags && <div className={cls(styles.tags)}>{tags}</div>}
  </div>
        )}
      </>
  )
}
